import { Item } from '@ntap/core';

export class JedinicaGradiva {
  constructor() {
    //
  }
  'en~jedinica_gradiva~glavni_naziv' = '';
  'en~jedinica_gradiva~arhivska_oznaka' = '';
  'en~jedinica_gradiva~id' = 0;
  'en~jedinica_gradiva~javno_objavljeno' = false;
  'en~jedinica_gradiva~status_dostupnosti' = '';
  'en~jedinica_gradiva~status_obrade' = '';
  'en~jedinica_gradiva~arhivist_na_obradi' = [];
  'en~jedinica_gradiva~voditelj_obrade' = [];
  'en~jedinica_gradiva~locked' = false;
  'en~jedinica_gradiva~rezidualni_podaci' = false;
  'en~jedinica_gradiva~posjednik' = 0;
  'en~jedinica_gradiva~nadredena_jedinica_gradiva' = 0;
}

type IJedinicaGradiva = JedinicaGradiva;

export function isJedinicaGradiva(item: Item): item is IJedinicaGradiva {
  return Object.keys(new JedinicaGradiva()).every(
    (key) => Object.keys(item).indexOf(key) > 0
  );
}
